// src/services/towerSiteService.js
import api from '../config/axios';

const BASE_PATH = '/tower-sites';

// ============= Query Operations =============

export const getAllTowerSites = async () => {
  const response = await api.get(BASE_PATH);
  return response.data;
};

export const getAllTowerSitesPaged = async (page = 0, size = 10, sort = 'siteId,asc') => {
  const response = await api.get(`${BASE_PATH}/paged`, {
    params: { page, size, sort }
  });
  return response.data;
};

export const getTowerSiteById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

export const getTowerSiteBySiteId = async (siteId) => {
  const response = await api.get(`${BASE_PATH}/site/${siteId}`);
  return response.data;
};

export const searchTowerSites = async (filters = {}, page = 0, size = 10) => {
  const response = await api.get(`${BASE_PATH}/search`, {
    params: {
      siteId: filters.siteId || undefined,
      siteName: filters.siteName || undefined,
      regional: filters.regional || undefined,
      kabupaten: filters.kabupaten || undefined,
      typeSiteContract: filters.typeSiteContract || undefined,
      projectId: filters.projectId || undefined,
      status: filters.status || undefined,
      page,
      size
    }
  });
  return response.data;
};

export const getTowerSitesByProject = async (projectId) => {
  const response = await api.get(`${BASE_PATH}/project/${projectId}`);
  return response.data;
};

// ============= Command Operations =============

export const createTowerSite = async (siteData) => {
  const response = await api.post(BASE_PATH, siteData);
  return response.data;
};

export const updateTowerSite = async (id, siteData) => {
  const response = await api.put(`${BASE_PATH}/${id}`, siteData);
  return response.data;
};

export const softDeleteTowerSite = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

// ============= Statistics Operations =============

export const getTowerSiteStatistics = async () => {
  const response = await api.get(`${BASE_PATH}/statistics`);
  return response.data;
};

// ============= Helper Functions =============

/**
 * Get type contract badge class
 */
export const getTypeContractBadgeClass = (typeContract) => {
  const types = {
    'MACRO': 'bg-green-100 text-green-800',
    'Macro': 'bg-green-100 text-green-800',
    'MICRO': 'bg-blue-100 text-blue-800'
  };
  return types[typeContract] || 'bg-gray-100 text-gray-800';
};

/**
 * Get regional badge class
 */
export const getRegionalBadgeClass = (regional) => {
  // You can customize colors per regional
  return 'bg-purple-100 text-purple-800';
};

/**
 * Get status display name
 */
export const getStatusDisplayName = (status) => {
  const statuses = {
    'STARTED': 'Started',
    'IN_PROGRESS': 'In Progress',
    'ON_HOLD': 'On Hold',
    'COMPLETED': 'Completed',
    'CLOSED': 'Closed'
  };
  return statuses[status] || status;
};

/**
 * Get status badge class
 */
export const getStatusBadgeClass = (status) => {
  const statuses = {
    'STARTED': 'bg-gray-100 text-gray-800',
    'IN_PROGRESS': 'bg-blue-100 text-blue-800',
    'ON_HOLD': 'bg-yellow-100 text-yellow-800',
    'COMPLETED': 'bg-green-100 text-green-800',
    'CLOSED': 'bg-red-100 text-red-800'
  };
  return statuses[status] || 'bg-gray-100 text-gray-800';
};

export default {
  getAllTowerSites,
  getAllTowerSitesPaged,
  getTowerSiteById,
  getTowerSiteBySiteId,
  searchTowerSites,
  getTowerSitesByProject,
  createTowerSite,
  updateTowerSite,
  softDeleteTowerSite,
  getTowerSiteStatistics,
  getTypeContractBadgeClass,
  getRegionalBadgeClass,
  getStatusDisplayName,
  getStatusBadgeClass
};